import { render, staticRenderFns } from "./LoyaltyPoints.vue?vue&type=template&id=df22414a&scoped=true&"
import script from "./LoyaltyPoints.vue?vue&type=script&lang=js&"
export * from "./LoyaltyPoints.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyPoints.vue?vue&type=style&index=0&lang=css&"
import style1 from "./LoyaltyPoints.vue?vue&type=style&index=1&lang=css&"
import style2 from "./LoyaltyPoints.vue?vue&type=style&index=2&id=df22414a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df22414a",
  null
  
)

export default component.exports